.container {
  width: 100%;
  padding: 0 1.6rem;
  overflow-y: auto;
}
